export default __webpack_public_path__ + "static/media/Screenshot_1619919123.7d20cdcf.png";